import { render, staticRenderFns } from "./ViewReport.vue?vue&type=template&id=265c8fc6&"
import script from "./ViewReport.vue?vue&type=script&lang=js&"
export * from "./ViewReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports